import CASAL_EXT_1 from "./CASAL_EXT_1";
export default {
  CASAL_EXT_1,
};
